import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { Backdrop, CircularProgress } from "@mui/material";

const FinalSubmissionDialog = ({
  open,
  onClose,
  onSubmit,
  isTimeUp,
  stats,
  submitError,
  countdownTime,
  finalSubmitChecked,
  onFinalSubmitCheck,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true); // dialog band, loader on
    try {
      await onSubmit();
    } catch (e) {
      // navigation nahi hui to loader band karo
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Full-screen loader — Dialog ke upar aata hai (zIndex 9999 > Dialog 1300) */}
      <Backdrop
        open={isSubmitting}
        sx={{
          zIndex: 9999,
          color: "#fff",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" size={48} />
        <Typography variant="h6" sx={{ mt: 1, textAlign: "center", px: 2 }}>
          Your exam will be submitted in a few seconds, please wait...
        </Typography>
      </Backdrop>

      {/* Dialog: isSubmitting hone par band ho jaata hai */}
      <Dialog open={open && !isSubmitting} onClose={onClose}>
        <DialogTitle>{isTimeUp ? "Time's Up!" : "Final Submission"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">Total Questions: {stats?.totalQuestions}</Typography>
            <Typography variant="body1">Total Answered: {stats?.attemptedWithAnswered}</Typography>
            <Typography variant="body1">Marked with answered: {stats?.markedWithAnswered}</Typography>
            <Typography variant="body1">Marked without answered: {stats?.markedWithotAnswered}</Typography>
            <Typography variant="body1">Not Answered: {stats?.attemptedWithoutAnswered}</Typography>
            <Typography variant="body1">Not Viewed: {stats?.notViewedQ}</Typography>
            {submitError && (
              <Typography color="red" variant="body1">
                {submitError}
              </Typography>
            )}
            {isTimeUp && countdownTime && (
              <Typography variant="body2" style={{ marginTop: "1rem" }}>
                You will be navigated in {countdownTime} seconds to the end page. Your exam has been submitted.
              </Typography>
            )}
          </DialogContentText>
          {!isTimeUp && (
            <FormControlLabel
              sx={{ alignItems: "flex-start", mt: 2 }}
              control={
                <Checkbox
                  checked={finalSubmitChecked}
                  onChange={onFinalSubmitCheck}
                  color="primary"
                  sx={{ pt: 0 }}
                />
              }
              label={<Typography sx={{ pt: "2px" }}>I confirm that I want to finally submit the exam.</Typography>}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" disabled={isTimeUp || isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            disabled={(!isTimeUp && !finalSubmitChecked) || isSubmitting}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FinalSubmissionDialog;
